/* Samago cart — micro-interacciones (no toca la lógica de cart.js / cart-drawer.js).
   1) Pulse suave del contador del header cuando aumenta (al agregar producto).
   2) Fade/colapso de la línea al tocar "Quitar" (visual mientras corre el AJAX). */
(function () {
  function pulse(el) {
    if (!el) return;
    el.classList.remove('samago-cart-pulse');
    void el.offsetWidth; // reinicia la animación
    el.classList.add('samago-cart-pulse');
  }

  function initBubble() {
    var bubble = document.querySelector('#cart-icon-bubble');
    if (!bubble || !('MutationObserver' in window)) return;
    function count() {
      var n = parseInt((bubble.textContent || '').replace(/\D/g, ''), 10);
      return isNaN(n) ? 0 : n;
    }
    var last = count();
    new MutationObserver(function () {
      var now = count();
      if (now > last) pulse(bubble);
      last = now;
    }).observe(bubble, { childList: true, subtree: true, characterData: true });
  }

  // Fade + colapso de la línea al quitar (la re-renderización de cart.js reemplaza la lista después).
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('.samago-cart-line__remove');
      if (!btn) return;
      var line = btn.closest('.samago-cart-line');
      if (line) line.classList.add('is-removing');
    },
    true
  );

  function init() {
    initBubble();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
